// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3K8e0","dot":"styles_dot__1l_3p"};